var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRisk = function SvgRisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.188 5.389v-2.09c0-.614.485-1.111 1.085-1.111h12.933c.6 0 1.086.497 1.086 1.11v13.404c0 .613-.486 1.11-1.086 1.11H3.273c-.6 0-1.086-.497-1.086-1.11v-5.894"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M4.602 10.585H5.81l1.41-1.468 2.254 4.79 2.091-7.813 1.18 4.49h1.996"
  })))));
};
export default SvgRisk;